import { SvgIcon, SvgIconProps } from "@mui/material";

export const DocumentIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 30 30">
    <path
      d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H17.5C18.0125 1.5625 18.4375 1.9875 18.4375 2.5C18.4375 3.0125 18.0125 3.4375 17.5 3.4375H11.25C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V12.5C26.5625 11.9875 26.9875 11.5625 27.5 11.5625C28.0125 11.5625 28.4375 11.9875 28.4375 12.5V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375Z"
      fill="currentColor"
    />
    <path
      d="M27.5 13.4357H22.5C18.225 13.4357 16.5625 11.7732 16.5625 7.49815V2.49815C16.5625 2.12315 16.7875 1.77315 17.1375 1.63565C17.4875 1.48565 17.8875 1.57315 18.1625 1.83565L28.1625 11.8357C28.425 12.0982 28.5125 12.5107 28.3625 12.8607C28.2125 13.2107 27.875 13.4357 27.5 13.4357ZM18.4375 4.76065V7.49815C18.4375 10.7232 19.275 11.5607 22.5 11.5607H25.2375L18.4375 4.76065Z"
      fill="currentColor"
    />
    <path
      d="M16.25 17.1875H8.75C8.2375 17.1875 7.8125 16.7625 7.8125 16.25C7.8125 15.7375 8.2375 15.3125 8.75 15.3125H16.25C16.7625 15.3125 17.1875 15.7375 17.1875 16.25C17.1875 16.7625 16.7625 17.1875 16.25 17.1875Z"
      fill="currentColor"
    />
    <path
      d="M13.75 22.1875H8.75C8.2375 22.1875 7.8125 21.7625 7.8125 21.25C7.8125 20.7375 8.2375 20.3125 8.75 20.3125H13.75C14.2625 20.3125 14.6875 20.7375 14.6875 21.25C14.6875 21.7625 14.2625 22.1875 13.75 22.1875Z"
      fill="currentColor"
    />
  </SvgIcon>
);
